<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col class="ion-activatable ion-tappable ripple-parent" (click)="modalCtrl.dismiss('share')"
               [class.disabled]="!canShare()">
        <ng-icon name="matIosShare"></ng-icon>
        <span>compartir</span>
        <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      </ion-col>
      <ion-col class="ion-activatable ion-tappable ripple-parent" (click)="modalCtrl.dismiss('save')"
               [class.disabled]="configService.isIos">
        <ng-icon name="matFileDownload"></ng-icon>
        <span>guardar</span>
        <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      </ion-col>
      <ion-col class="ion-activatable ion-tappable ripple-parent" (click)="modalCtrl.dismiss('open')">
        <ng-icon name="matOpenInNew"></ng-icon>
        <span>abrir</span>
        <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>